import {
  QueryDocumentSnapshot,
  WithFieldValue,
  FirestoreDataConverter,
  Timestamp,
} from 'firebase/firestore';
import {
  Meal,
  MealVersioned,
  UserProfile,
  UserProfileVersioned,
  upgradeMeal,
  upgradeUserProfile,
} from '@llm-macro-tracker/shared';

// Utility Functions
function convert(obj: any): any {
  for (const prop in obj) {
    if (obj[prop] instanceof Timestamp) {
      obj[prop] = obj[prop].toDate();
    } else if (typeof obj[prop] === 'object') {
      convert(obj[prop]);
    } else if (Array.isArray(obj[prop])) {
      obj[prop].forEach(convert);
    }
  }
  return obj;
}

function toJS<T>(doc: QueryDocumentSnapshot, id?: string): T {
  return { ...convert(doc.data()), id: id ? id : doc.id } as T;
}

// Firestore Converters
export const mealConverter: FirestoreDataConverter<Meal> = {
  toFirestore: (meal: WithFieldValue<Meal>) => {
    return meal;
  },
  fromFirestore: (snapshot: QueryDocumentSnapshot) => {
    const meal = toJS<MealVersioned>(snapshot);
    return upgradeMeal(meal);
  },
};

export const userProfileConverter: FirestoreDataConverter<UserProfile> = {
  toFirestore: (profile: WithFieldValue<UserProfile>) => {
    return profile;
  },
  fromFirestore: (snapshot: QueryDocumentSnapshot) => {
    const profile = toJS<UserProfileVersioned>(snapshot);
    return upgradeUserProfile(profile);
  },
};
